import * as effects from 'redux-saga/effects';
import { Backend } from '../../Backend/Backend';
import { Logger } from '../../Utils/Logger';
import {
	recoveredMultipleUsername,
	recoveredSingleUsername,
	recoverUsernameFromEmailAdress,
	recoverUsernameFromEmailAdressFailed,
	recoverUsernameFromEmailAdressSucceed,
	sendResetPasswordEmail,
	sendResetPasswordEmailFailed,
	sendResetPasswordEmailSucceed,
} from './Actions';
import { IResetPasswordActionTypes } from './Types';

function* handleSendResetPasswordEmail(
	action: ReturnType<typeof sendResetPasswordEmail>
) {
	const backend = Backend.getInstance();

	try {
		// @ts-ignore
		const res = yield effects.apply(
			backend,
			backend.sendResetPasswordEmail,
			action.payload as any
		);
		if (res.message === "Plus d'un username est associé à ce compte") {
			yield effects.put(recoveredMultipleUsername());
			yield effects.put(recoverUsernameFromEmailAdressSucceed());
		} else {
			yield effects.put(recoveredSingleUsername(res.username));
			yield effects.put(recoverUsernameFromEmailAdressSucceed());
			yield effects.put(sendResetPasswordEmailSucceed());
			Logger.info('Successfully sending mail');
		}
	} catch (err) {
		yield effects.put(
			sendResetPasswordEmailFailed("Cet utilisateur n'a pas été retrouvé")
		);
		Logger.warn({ err }, 'Failed sending mail');
	}
}

function* handleRecoverUsernameFromEmailAdress(
	action: ReturnType<typeof recoverUsernameFromEmailAdress>
) {
	const backend = Backend.getInstance();

	try {
		// @ts-ignore
		const res = yield effects.apply(
			backend,
			backend.recoverUsernameFromEmailAdress,
			action.payload as any
		);
		if (res.message === "Plus d'un username est associé à ce compte") {
		}
		yield effects.put(recoverUsernameFromEmailAdressSucceed());

		Logger.info('Successfully recovered username');
	} catch (err) {
		yield effects.put(
			recoverUsernameFromEmailAdressFailed(
				'Aucun compte associé à cet email'
			)
		);
		Logger.warn({ err }, 'Failed sending mail');
	}
}

function* watchSendResetPasswordEmail() {
	yield effects.takeEvery(
		IResetPasswordActionTypes.SEND_RESET_PASSWORD_EMAIL,
		handleSendResetPasswordEmail
	);
}

function* watchRecoverUsernameFromEmailAdress() {
	yield effects.takeEvery(
		IResetPasswordActionTypes.RECOVER_USERNAME_FROM_EMAIL,
		handleRecoverUsernameFromEmailAdress
	);
}

export function* ResetPasswordSaga(): Generator<
	effects.AllEffect<effects.ForkEffect<void>>,
	void
> {
	yield effects.all([effects.fork(watchSendResetPasswordEmail)]);
	yield effects.all([effects.fork(watchRecoverUsernameFromEmailAdress)]);
}
